/** Merge locale overrides at each English leaf, preserving the canonical namespace shape. */
export function mergeCatalogs<Catalog extends Record<string, unknown>>(english: Catalog, translated: unknown): Catalog {
  const overrides = isCatalogObject(translated) ? translated : {}
  const merged = Object.fromEntries(Object.entries(english).map(([key, value]) => {
    const override = overrides[key]
    if (typeof value === "string") return [key, typeof override === "string" && override.length > 0 ? override : value]
    if (isCatalogObject(value)) return [key, mergeCatalogs(value, override)]
    return [key, value]
  }))
  // Recursion fills every canonical English key; only translated string values replace leaves.
  return merged as Catalog
}

function isCatalogObject(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value)
}
